import { useTranslation } from "react-i18next";

export default function ExpertValidation() {
  const { t } = useTranslation();
  return (
    <>
      <div>
        <h2>{t("Expert Validation")}</h2>
        <p>{t("Your prescription is being validated by our experts. Once finalized, your prescription will be generated and issued")}</p>
      </div>
    </>
  );
}
